import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { dataService, ApiKey, ApiKeyCreated } from '../services/data';

export function useApiKeys() {
  return useQuery<ApiKey[], Error>({
    queryKey: ['apiKeys'],
    queryFn: () => dataService.getApiKeys(),
  });
}

export function useCreateApiKey() {
  const queryClient = useQueryClient();

  return useMutation<ApiKeyCreated, Error, string>({
    mutationFn: (name: string) => dataService.createApiKey(name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
    },
  });
}

export function useRevokeApiKey() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (id: string) => dataService.revokeApiKey(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
    },
  });
}
